import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit, OnChanges, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { OwnerPropertyDetails } from '../owner-property-details/owner-property-details';
import { OwnerPropertyDetailsService } from '../owner-property-details.service';
import { OwnerPropertyComponent } from '../owner-property-details/owner-property-details.component';


@Component({
    selector: "app-owner-property-details-list",
    templateUrl: "./owner-property-details-list.component.html",
    styleUrls: ["./owner-property-details-list.component.css"],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class OwnerPropertyListComponent implements OnInit, OnChanges {
	constructor(
		private ownerPropertyDetailsService: OwnerPropertyDetailsService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = ownerPropertyDetailsService.ownerPropertystatuses
	}
	// data

	@Input() ownerLeadProfileId: any;
	@Input() updateIncome: boolean = false;
	@Input() isPublicAndPublish: boolean;
	@Input() showFilter = true;
	@Input() showPagination = true;

	@Output() doUpdate = new EventEmitter<any>();

	propertyLeadProfiles: any;
	ownerPropertyDetail: any;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'propertyLeadProfileGuestAPI.subjAdrDevelopmentName', header: 'Development', width: 'auto' },
		{ field: 'propertyLeadProfileGuestAPI.subjAdrStreet', header: 'Street', width: 'auto' },
		{ field: 'propertyLeadProfileGuestAPI.subjAdrUnit', header: 'Unit', width: 'auto' },
		{ field: 'propertyLeadProfileGuestAPI.subjAdrCity', header: 'City', width: 'auto' },
		{ field: 'propertyLeadProfileGuestAPI.subjAdrState', header: 'State', width: 'auto' }
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	ngOnChanges() {
		this.ngOnInit();
	}  


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'seasonStart', order: -1 });
			}
			if(this.ownerLeadProfileId)
			{
				// show only property leads that are assigned to this ownerLeadProfileId
				let propertyFilter = { 'ownerLeadProfileId': { 'value': this.ownerLeadProfileId, 'matchMode': 'in' } };
				Object.assign(event.filters, propertyFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.ownerPropertyDetailsService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.propertyLeadProfiles = res.data.propertyLeadProfiles;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.propertyLeadProfiles = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	getAssignedPropertyLeadIds(propertyLeadProfiles) {
		let propertyIdList = [];
		propertyLeadProfiles.forEach(property => {
			propertyIdList.push(property.propertyLeadProfileId);
		});
		return propertyIdList;
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Owner Property Lead Details',
			ownerLeadProfileId: this.ownerLeadProfileId,
			assignedPropertyLeadIds : this.getAssignedPropertyLeadIds(this.propertyLeadProfiles),
			isEditForm: false
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerPropertyComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPropertyLeadProfilesCB(data);
				this.doUpdate.emit(data);
				this.ngOnInit();
				// close the dialogBox
				dialogRef.close();
			});

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addPropertyLeadProfilesCB(data);
				this.doUpdate.emit(data);
				this.ngOnInit();
				// close the dialogBox
				dialogRef.close();
			});
	}

	/*********
	* Edit Button
	*
	*/
	onOpenFormEdit(ownerPropertyDetail: OwnerPropertyDetails) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			ownerLeadProfile: ownerPropertyDetail,
			title: 'Edit Owner Property Details',
			assignedPropertyLeadIds : this.getAssignedPropertyLeadIds(this.propertyLeadProfiles),
			isEditForm: true
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(OwnerPropertyComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updatePropertyLeadProfilesCB(data);
				this.doUpdate.emit(data);
				this.ngOnInit();
				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				// this.deletePropertyLeadProfilesCB(data);
				this.doUpdate.emit(data);
				this.ngOnInit();
				// close the dialogBox
				dialogRef.close();
			});
	}

	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addPropertyLeadProfilesCB(ownerPropertyDetail: OwnerPropertyDetails) {
		console.log('Adding ProformaIncome: ' + JSON.stringify(ownerPropertyDetail));
		// if we don't have a ownerPropertyDetail array yet...
		if (!this.propertyLeadProfiles) {
			this.propertyLeadProfiles = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.propertyLeadProfiles.unshift(ownerPropertyDetail);

		// no idea what this is but it is required to update the array
		this.propertyLeadProfiles = [...this.propertyLeadProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerPropertyDetails ' + ownerPropertyDetail.propertyLeadProfileId + ' Added', life: 3000 });
	}

	updatePropertyLeadProfilesCB(ownerPropertyDetail: OwnerPropertyDetails) {
		console.log('Updating propertyLeadProfiles: ' + JSON.stringify(ownerPropertyDetail));
		let itemIndex = this.propertyLeadProfiles.findIndex((item: any) => item.propertyLeadProfileId === ownerPropertyDetail.propertyLeadProfileId);
		this.propertyLeadProfiles[itemIndex] = ownerPropertyDetail;

		// no idea what this is but it is required to update the array
		this.propertyLeadProfiles = [...this.propertyLeadProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerPropertyDetails ' + ownerPropertyDetail.propertyLeadProfileId + ' Updated', life: 3000 });
	}

	deletePropertyLeadProfilesCB(ownerPropertyDetail: OwnerPropertyDetails) {
		console.log('Removing ownerPropertyDetails: ' + ownerPropertyDetail);
		this.propertyLeadProfiles.splice(this.propertyLeadProfiles.indexOf(ownerPropertyDetail), 1);
		this.recordTotal = this.propertyLeadProfiles.length;

		// no idea what this is but it is required to update the array
		this.propertyLeadProfiles = [...this.propertyLeadProfiles];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'OwnerPropertyDetails ' + ownerPropertyDetail.propertyLeadProfileId + ' Deleted', life: 3000 });
	}

	getStatus() {
		return
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.propertyLeadProfiles ? this.first === (this.propertyLeadProfiles.length - this.rows) : true; }
	isFirstPage(): boolean { return this.propertyLeadProfiles ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(ownerPropertyDetail: any) {
		if (ownerPropertyDetail?.status) {
			const status = this.statuses.find((e: any) => e.value == ownerPropertyDetail.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}
}